import { render, staticRenderFns } from "./popup-set-price.vue?vue&type=template&id=8d318860&scoped=true"
import script from "./popup-set-price.vue?vue&type=script&lang=js"
export * from "./popup-set-price.vue?vue&type=script&lang=js"
import style0 from "./popup-set-price.vue?vue&type=style&index=0&id=8d318860&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d318860",
  null
  
)

export default component.exports